import React from 'react'

export const PLACEMENT_TOP = 'top'
export const PLACEMENT_BOTTOM = 'bottom'
export const PLACEMENT_LEFT = 'left'
export const PLACEMENT_RIGHT = 'right'

const TooltipV3 = ({
  placement = PLACEMENT_TOP,
  title,
  children,
}) => {
  if (!title) {
    return children
  }

  return (
    <span className="tooltip">
      <span className={`tooltip-text tooltip-text--${placement}`}>
        {title}
      </span>
        {children}
    </span>
  )
}

export default TooltipV3
